import { Text, Img, Heading } from "./..";
import React from "react";

export default function UserProfile({
  userImage = "images/img_image_59.png",
  userName = "Anil Kumar",
  userPosition = "Chief Executive Officer",
  ...props
}) {
  return (
    <div
      {...props}
      className={`${props.className} relative w-full md:h-auto`} // Use full width for each profile container
    >
      <Img
        src={userImage}
        alt="Profile Image"
        className="w-full h-full object-cover" // Ensures the image takes the full width and height of the container without getting cropped
      />
      <div className="absolute bottom-[24.84px] left-0 right-0 mx-auto flex w-[76%] flex-col items-start md:justify-start">
        <div className="flex items-center gap-[7px] self-stretch">
          <Heading size="heading3xl" as="h5" className="text-[20.22px] font-bold text-white">
            {userName}
          </Heading>
          <Img src="images/img_link.svg" alt="Link Image" className="h-[16px]" />
        </div>
        <Text size="textmd" as="p" className="relative mt-[-2px] text-[11.19px] font-normal text-white">
          {userPosition}
        </Text>
      </div>
    </div>
  );
}
